import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class ActiveAdditionalFilters {
  private filterMap = new Map<string, boolean>();

  constructor() {
    this.filterMap.set('category', false);
    this.filterMap.set('price', false);
    this.filterMap.set('roomCount', false);
    this.filterMap.set('livingSpace', false);
    this.filterMap.set('usageSpace', false);
    this.filterMap.set('propertySpace', false);
  }

  set(filterName: string, isInAdditionalFilters: boolean) {
    this.filterMap.set(filterName, isInAdditionalFilters);
  }

  get(filterName: string): boolean {
    return this.filterMap.get(filterName) || false;
  }

  reset() {
    for (const key of this.filterMap.keys()) {
      this.filterMap.set(key, false);
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class DesktopFilterService {
  activeAdditionalFilters = new ActiveAdditionalFilters();

  private layoutUpdateRequest$ = new Subject<void>();

  get layoutUpdateRequest(): Observable<void> {
    return this.layoutUpdateRequest$.asObservable();
  }

  requestLayoutUpdate() {
    this.layoutUpdateRequest$.next();
  }
}
